letterAdjust.scale = 0.9;
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
	".": "M672-98v-312H360v312H672z",
	"'": "M360,1638h311l0-648H360L360,1638z",
	"-": "M1008,770V459H360v311H1008z",
	"0": "M0 536q0 -284 46 -391q62 -145 252 -145q191 0 254 145q46 104 46 391q0 309 -55 414q-61 115 -245 115q-185 0 -245 -115q-53 -102 -53 -414zM207 534q0 255 13 308q10 73 78 73q64 0 79 -73q12 -57 12 -308q0 -253 -13 -310q-17 -74 -78 -74t-76 74q-15 66 -15 310z ",
	"1": "M0 700v201q133 75 205 164h201v-1065h-228v820q-80 -67 -178 -120z",
	"2": "M0 0v185l322 429q74 100 74 195q0 102 -78 102q-56 0 -77 -51q-15 -33 -15 -100h-208q-2 19 -2 38q0 130 80 200q76 67 208 67q304 0 304 -271q0 -182 -152 -357l-234 -275h396v-162h-618z",
	"3": "M0 296h209q0 -72 11 -99q17 -47 77 -46q103 2 102 162q0 105 -43 134q-38 26 -153 24v168q106 -7 139 19q38 29 39 131q0 124 -79 124q-52 0 -69 -37q-13 -25 -12 -82h-209q-2 153 72 217q60 54 223 54q148 0 216 -64t68 -213q0 -210 -140 -230v-2q92 -18 129 -91 q28 -56 28 -161q0 -304 -323 -304q-159 0 -222 68t-63 228z",
	"4": "M0 244h326v-244h209v244h84v164h-84v657h-281l-254 -607v-214zM164 408l192 509h2l-14 -509h-180z",
	"5": "M0 261h212q0 -51 14 -74q20 -34 64 -34q60 0 79 50q15 36 15 159q0 98 -8 131q-19 80 -82 80q-77 0 -77 -119h-205v611h544v-162h-336l1 -265q48 70 151 70q138 0 187 -113q34 -75 34 -233q0 -188 -65 -270q-72 -92 -251 -92q-285 0 -277 261z",
	"6": "M0 445q0 -206 43 -301q65 -144 246 -144q310 0 310 354q0 332 -229 332q-51 0 -90 -19q-30 -13 -77 -53q0 204 14 252q16 56 81 56q79 0 73 -94h216q1 237 -272 237q-205 0 -267 -153q-48 -117 -48 -467zM209 335q0 115 13 154q18 53 74 53q65 0 84 -68q9 -33 9 -121 q0 -93 -9 -128q-19 -74 -87 -75q-43 0 -63.5 46t-20.5 139z",
	"7": "M0 901v164h568v-202l-255 -863h-240l292 901h-365z",
	"8": "M0 281q0 -281 300 -281q299 0 299 281q0 110 -26 169q-35 78 -126 112v4q143 35 143 223q0 276 -290 276q-289 0 -290 -276q0 -94 26 -142q33 -61 117 -81v-4q-90 -32 -126 -112q-27 -60 -27 -169zM211 292q0 82 9 118q21 68 80 68t80 -68q10 -38 10 -118 q0 -141 -90 -142q-89 0 -89 142zM218 780q0 135 82 135q81 0 81 -135q0 -141 -81 -141q-82 0 -82 141z",
	"9": "M0 696q0 -116 51 -192q58 -87 169 -87q101 0 170 67l-6 -259q-17 -74 -86 -74q-39 0 -61 34q-16 26 -16 73h-205q-4 -140 68 -202q66 -56 209 -56q201 0 267 168q39 98 39 360q0 286 -37 379q-62 158 -268 158q-294 0 -294 -369zM209 739q0 80 11 116q19 67 78 67 q92 0 92 -179q0 -185 -93 -185q-58 0 -77 65q-11 35 -11 116z",
	"A": "M289 -410l311 2048h465l311 -2048h-315l-68 443h-321l-68 -443h-315zM721 346h225l-112 739z",
	"B": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -14t68.5 -29.5t66.5 -49.5t56.5 -75t47 -102t29.5 -136t12.5 -176q0 -78 -24.5 -152t-59.5 -123t-68.5 -87t-58.5 -54l-25 -19q10 -6 25.5 -18t56.5 -54t72 -89t56.5 -121t25.5 -152q0 -96 -12.5 -176t-29.5 -136 t-47 -102.5t-56.5 -75t-66.5 -49t-68.5 -29.5t-72.5 -14.5t-66.5 -6.5t-61.5 -1h-480zM674 -98h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557zM674 770h166q70 0 119 82t49 196.5t-49.5 196.5t-118.5 82h-166v-557z",
	"C": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089q0 -70 48.5 -118t118 -48t118.5 48t49 118v249h314v-249q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
	"D": "M360 -410v2048h480q199 0 340 -140t141 -339v-1089q0 -199 -141.5 -339.5t-339.5 -140.5h-480zM674 -96h166q70 0 119 48t49 118v1089q0 70 -49.5 119t-118.5 49h-166v-1423z",
	"E": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-557h491v-312h-803z",
	"F": "M360 -410v2048h803v-311h-491v-557h336v-311h-336v-869h-312z",
	"G": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-250h-314v250q0 70 -49 118t-118.5 48t-119 -48t-49.5 -118v-1089q0 -70 49.5 -118t119 -48t118.5 48t49 118v233h-168v311h482v-1024h-158l-70 187q-4 -8 -11 -20.5t-34.5 -45.5t-63.5 -56.5t-96.5 -44 t-132.5 -20.5q-190 0 -292.5 135.5t-102.5 344.5z",
	"H": "M360 -410v2048h314v-868h334v868h313v-2048h-313v869h-334v-869h-314z",
	"I": "M360 -410v2048h312v-2048h-312z",
	"J": "M293 -98h168q70 0 119 49t49 119v1568h311v-1568q0 -199 -140.5 -339.5t-338.5 -140.5h-168v312z",
	"K": "M360 -410v2048h312v-649l336 649h313l-365 -704l365 -1344h-313l-256 947l-80 -152v-795h-312z",
	"L": "M362 -410v2048h312v-1736h491v-312h-803z",
	"M": "M360 -410v2048h420l221 -1212l220 1212h419v-2048h-313v1414l-254 -1414h-145l-256 1414v-1414h-312z",
	"N": "M360 -410v2048h314l334 -1060v1060h313v-2048h-313l-334 1061v-1061h-314z",
	"O": "M344 70v1089q0 199 140.5 339t339 140t340 -140t141.5 -339v-1089q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5zM657 70q0 -70 48.5 -118t118 -48t118.5 48t49 118v1089q0 70 -49 118t-118.5 48t-118 -48t-48.5 -118v-1089z",
	"P": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181t-12.5 -180t-29.5 -141.5t-47 -105.5t-56.5 -75.5t-66.5 -50t-68.5 -31t-72.5 -16.5t-66.5 -6h-61.5h-168v-834h-312zM672 735h168q168 0 168 296 t-168 296h-168v-592z",
	"Q": "M344 68v1089q0 199 141.5 340t340 141t340 -141t141.5 -340v-1089q-1 -113 -50 -211q66 -53 148 -54v-311q-209 0 -350 152q-106 -57 -230 -58q-199 0 -340 141.5t-141 340.5zM657 68q0 -70 49.5 -119t119 -49t118.5 49t49 119v1089q0 70 -49 119t-118.5 49t-119 -49 t-49.5 -119v-1089z",
	"R": "M360 -410v2048h480q39 0 61.5 -1t66.5 -6t72.5 -15t68.5 -30.5t66.5 -50.5t56.5 -77t47 -105.5t29.5 -141.5t12.5 -181q0 -440 -221 -559l221 -881h-322l-211 834h-116v-834h-312zM674 735h166q168 0 168 295t-168 295h-166v-590z",
	"S": "M344 70v110h313v-110q0 -70 48.5 -118t118 -48t118.5 48t49 118q0 82 -27.5 153.5t-72.5 124.5t-103.5 108.5t-120 103.5t-118.5 110.5t-103.5 128t-74 159t-27.5 201.5q0 199 140.5 339t339 140t340 -140t141.5 -339v-110h-314v110q0 70 -49 118t-118.5 48t-118 -48 t-48.5 -118q0 -74 21.5 -136t59.5 -109.5t86 -91.5t102.5 -86t107.5 -87t102.5 -101t86.5 -123t59.5 -157t22.5 -198q0 -199 -140.5 -339.5t-340 -140.5t-340 140.5t-140.5 339.5z",
	"T": "M330 1325v313h960v-313h-323v-1735h-314v1735h-323z",
	"U": "M356 70v1568h312v-1568q0 -70 49 -118t118.5 -48t119 48t49.5 118v1568h313v-1568q0 -199 -141.5 -339.5t-340 -140.5t-339 140.5t-140.5 339.5z",
	"V": "M315 1638h314l166 -1099l168 1099h313l-313 -2048h-334z",
	"W": "M315 1638h314l166 -1179l168 1179h241l168 -1179l168 1179h311l-311 -2048h-336l-121 1024l-120 -1024h-334z",
	"X": "M338 -410l324 1024l-324 1024h313l166 -530l168 530h313l-323 -1024l323 -1024h-313l-168 531l-166 -531h-313z",
	"Y": "M297 1638h326l186 -606l186 606h326l-356 -1163v-885h-312v885z",
	"Z": "M358 -98l648 1423h-648v313h961v-313l-649 -1423h649v-312h-961v312z"
};
var font_size = 21,
	panel_Hor_Adjustment = -1,
	font_Top_Adjustment = -6,
	tracking = 0,
	small_Caps_Adjustment = {
		vertical: 0,
		horizontal: 0,
		scale_width: 0,
		scale_height: 0,
	},
	colors = {
		characters: {
			home: [
				"#FFFFFF"
			],
			away: [
			]
		},
		numbers: {
			home: [
				'#d31245',
				"#FFFFFF",
				"#FFFFFF",
				"#58595B"
			],
			away: [
			]
		}
	},
	outlines = {
		characters: {
			width: 4 // also acts as tracking if no outlines exsist
		},
		numbers: {
			width: 2
		}
	},
	special_Character_Adjustments = {
		period: {
			vertical: 3, // this moves it up from the bottom
			horizontal: -2.5,
			scale_width: 15.5,
			scale_height: 15.5,
		},
		hyphen: {
			vertical: 0,
			horizontal: -5.5,
			scale_width: 0,
			scale_height: -12,
		},
		apostrophe: {
			vertical: -5.75,
			horizontal: -2.5,
			scale_width: 0,
			scale_height: 0,
		}
	},
	number_Adjustments = {
		top: 9,
		left: -4,
		width: 120,
		height: 85,
		middle_Space: 6,
	};